(() => {
  if (window.PBLogoV3) return;
  const V = window.PBVariantV2;
  const configEl = document.querySelector('[data-pb-logo-v3-config]');
  if (!V || !configEl) return;

  let CONFIG = {};
  try { CONFIG = JSON.parse(configEl.textContent || '{}'); }
  catch (error) { console.error('PB Logo V3 config error', error); return; }

  const q = (r, s) => r?.querySelector(s) || null;
  const qa = (r, s) => r ? [...r.querySelectorAll(s)] : [];
  const n = V.normalize;
  const active = (r, s) => q(r, `${s}.is-active`);
  const selectedData = (r, s, key, fallback = '') => active(r, s)?.dataset?.[key] || fallback;
  const parse = (r, s, fallback) => {
    try { return JSON.parse(q(r, s)?.textContent || JSON.stringify(fallback)); }
    catch { return fallback; }
  };
  const money = cents => new Intl.NumberFormat(undefined, {
    style: 'currency', currency: CONFIG.currency || window.Shopify?.currency?.active || 'USD'
  }).format(Number(cents || 0) / 100);
  const message = (root, text) => {
    const el = q(root, '[data-pb-message]');
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
  };
  const boxVariant = (variants, color, state) => V.resolveVariant(variants || [], {
    domain: 'box', state, requiredValues: [color]
  });
  const usbVariant = (variants, capacity, state) => V.resolveVariant(variants || [], {
    domain: 'usb', state, requiredValues: [capacity]
  });
  const currentColor = root => selectedData(root, '[data-color]', 'color', 'Cream');
  const currentCapacity = root => selectedData(root, '[data-usb-capacity]', 'usbCapacity', '8GB');
  const currentFoil = root => {
    const button = active(root, '[data-foil]');
    return {
      name: button?.dataset?.foil || 'Matte Gold',
      color: button?.dataset?.foilColor || '#C8A95A'
    };
  };
  const currentBoxFoil = root => {
    const button = active(root, '[data-box-foil-name]');
    return {
      name: button?.dataset?.boxFoilName || 'Shiny Gold',
      color: button?.dataset?.boxFoilColor || '#d9bd6a'
    };
  };
  const currentUsbColor = (root, product) => {
    const type = n(product?.type || root.dataset.usbType || 'crystal');
    return type.includes('wood') ? '#1D0200' : '#ffffff';
  };
  const uid = () => {
    if (window.crypto?.randomUUID) return `PB-DIE-${window.crypto.randomUUID()}`;
    return `PB-DIE-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
  };

  const SAVED_DIES = (() => {
    const raw = CONFIG.customerDies;
    const values = Array.isArray(raw) ? raw : Array.isArray(raw?.dies) ? raw.dies : [];
    return values.filter(die => n(die?.status) === 'active');
  })();

  let cartPromise = null;
  const getCart = (fresh = false) => {
    if (!fresh && cartPromise) return cartPromise;
    cartPromise = fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      headers: { Accept: 'application/json' }
    }).then(response => {
      if (!response.ok) throw new Error('Could not read cart');
      return response.json();
    }).catch(error => {
      console.warn('PB Logo V3 cart read failed', error);
      return { items: [] };
    });
    return cartPromise;
  };

  const property = (props, ...keys) => {
    if (!props) return '';
    for (const key of keys) if (props[key]) return props[key];
    return '';
  };

  const currentOrderDies = async () => {
    const cart = await getCart();
    const setupId = String(CONFIG.setupVariantId || '');
    const paidRequests = new Set();
    (cart.items || []).forEach(item => {
      const props = item.properties || {};
      if (String(item.variant_id || item.id) === setupId || props._PB_Internal_Fee === 'Logo Die Setup') {
        const request = props._PB_Die_Request_ID;
        if (request) paidRequests.add(String(request));
      }
    });

    const seen = new Set();
    const dies = [];
    (cart.items || []).forEach(item => {
      const props = item.properties || {};
      if (String(item.variant_id || item.id) === setupId || props._PB_Internal_Fee === 'Logo Die Setup') return;
      const requestId = props._PB_Die_Request_ID;
      const profile = props._PB_Die_Profile;
      if (!requestId || !profile || seen.has(String(requestId))) return;
      seen.add(String(requestId));
      const artwork = property(props, 'Logo Artwork', 'Box Logo Artwork', '_PB_Artwork_Reuse_URL', '_PB_Artwork_URL');
      dies.push({
        source: 'cart',
        requestId: String(requestId),
        name: props._PB_Logo_Name || props['Logo Name'] || 'Logo already uploaded',
        profile: String(profile),
        artworkUrl: artwork || '',
        setupPaid: paidRequests.has(String(requestId))
      });
    });
    return dies;
  };

  const profileForProduct = product => {
    const handle = product?.handle || '';
    return CONFIG.relatedBoxProfiles?.[handle] || (handle ? `product:${handle}` : CONFIG.productDieProfile);
  };

  const profileFor = (root, kind, products = {}) => {
    if (kind === 'box') return CONFIG.productDieProfile;
    if (kind === 'addon') {
      const key = selectedData(root, '[data-box-key]', 'boxKey');
      return profileForProduct(products[key] || {});
    }
    return '';
  };

  const ensureStyles = () => {
    if (document.getElementById('pb-logo-v3-style')) return;
    const style = document.createElement('style');
    style.id = 'pb-logo-v3-style';
    style.textContent = `
      .pb-logo-v3[hidden]{display:none!important}.pb-logo-v3{margin-top:1.2rem;padding:1.45rem;border:1px solid rgba(var(--color-foreground),.16);border-radius:9px;background:rgba(var(--color-foreground),.025)}
      .pb-logo-v3 h4{margin:0 0 .5rem;font-size:1.65rem}.pb-logo-v3 p{margin:.35rem 0 .9rem!important;line-height:1.45}.pb-logo-v3__muted{font-size:1.2rem;opacity:.7}
      .pb-logo-v3__signin{padding:1.2rem;border:1px dashed rgba(var(--color-foreground),.25);border-radius:8px}.pb-logo-v3__signin a{display:inline-flex;margin-top:.5rem;font-weight:600;text-decoration:underline;text-underline-offset:3px}
      .pb-logo-v3__sources{display:grid;gap:.75rem;margin:.9rem 0}.pb-logo-v3__source{width:100%;display:flex;justify-content:space-between;align-items:flex-start;gap:1rem;padding:1rem 1.1rem;border:1px solid rgba(var(--color-foreground),.18);border-radius:7px;background:rgb(var(--color-background));color:rgb(var(--color-foreground));font:inherit;text-align:left;cursor:pointer}
      .pb-logo-v3__source.is-active{outline:2px solid rgb(var(--color-foreground));outline-offset:-2px}.pb-logo-v3__source strong{display:block}.pb-logo-v3__source small{display:block;margin-top:.2rem;opacity:.7;line-height:1.3}.pb-logo-v3__source-price{flex:0 0 auto;font-weight:600;white-space:nowrap}
      .pb-logo-v3__fields{margin-top:1rem}.pb-logo-v3__field{margin-top:1rem}.pb-logo-v3__field label{display:block;font-weight:600;margin-bottom:.45rem}.pb-logo-v3__field input[type="text"]{width:100%;min-height:4.2rem;border:1px solid rgba(var(--color-foreground),.25);border-radius:6px;padding:.8rem 1rem;background:rgb(var(--color-background));color:rgb(var(--color-foreground));font:inherit}
      .pb-logo-v3__file{display:block;width:100%;margin:.6rem 0}.pb-logo-v3__preview-help{padding:.9rem 1rem;margin-top:.8rem;border-left:3px solid rgba(var(--color-foreground),.28);background:rgba(var(--color-foreground),.035);font-size:1.22rem;line-height:1.45}
      .pb-logo-v3__preview{position:absolute;z-index:6;pointer-events:none;display:flex;align-items:center;justify-content:center;text-align:center;color:#C8A95A}.pb-logo-v3__preview[hidden]{display:none!important}.pb-logo-v3__preview--box{left:50%;top:50%;transform:translate(-50%,-50%);width:48%;height:30%}.pb-logo-v3__preview--usb{left:15%;top:40.5%;width:31%;height:13%}
      .pb-logo-v3__preview img{max-width:100%;max-height:100%;width:auto;height:auto;object-fit:contain;filter:drop-shadow(0 1px 1px rgba(0,0,0,.08))}.pb-logo-v3__placeholder{font-family:Georgia,serif;font-size:clamp(1.2rem,1.8vw,2.1rem);line-height:1.15;opacity:.82}
      .pb-logo-v3__status{margin-top:.75rem;font-size:1.2rem;opacity:.72}.pb-logo-v3__status.is-success{opacity:.9}.pb-logo-v3__section-title{margin:1.1rem 0 .4rem;font-size:1.25rem;text-transform:uppercase;letter-spacing:.07em;opacity:.65}
    `;
    document.head.appendChild(style);
  };
  ensureStyles();

  const previewFor = (root, kind) => {
    const wrap = q(root, '.pb-photo-customizer__preview-wrap');
    if (!wrap) return null;
    let preview = q(wrap, `[data-pb-logo-v3-preview="${kind}"]`);
    if (!preview) {
      preview = document.createElement('div');
      preview.className = `pb-logo-v3__preview pb-logo-v3__preview--${kind === 'usb' ? 'usb' : 'box'}`;
      preview.dataset.pbLogoV3Preview = kind;
      preview.hidden = true;
      preview.innerHTML = '<span class="pb-logo-v3__placeholder">Your logo will be applied here</span>';
      wrap.appendChild(preview);
    }
    return preview;
  };

  const hideTextPreview = root => {
    const text = q(root, '[data-pb-preview-text]');
    if (text) text.style.setProperty('display', 'none', 'important');
  };
  const restoreTextPreview = root => {
    const text = q(root, '[data-pb-preview-text]');
    if (text) text.style.removeProperty('display');
  };

  const placeholder = (panel, text = 'Your logo will be applied here') => {
    if (!panel.preview) return;
    panel.preview.innerHTML = '';
    const span = document.createElement('span');
    span.className = 'pb-logo-v3__placeholder';
    span.textContent = text;
    panel.preview.appendChild(span);
    panel.preview.hidden = false;
  };

  const hexToRgb = hex => {
    const clean = String(hex || '#C8A95A').replace('#', '').trim();
    const value = clean.length === 3 ? clean.split('').map(x => x + x).join('') : clean.padEnd(6, '0').slice(0, 6);
    const number = Number.parseInt(value, 16);
    return { r: (number >> 16) & 255, g: (number >> 8) & 255, b: number & 255 };
  };

  const renderSvgFileNow = async (panel, file, targetColor) => {
    if (!file || !String(file.name || '').toLowerCase().endsWith('.svg')) {
      placeholder(panel);
      return false;
    }
    try {
      const url = URL.createObjectURL(file);
      const image = new Image();
      await new Promise((resolve, reject) => {
        image.onload = resolve;
        image.onerror = reject;
        image.src = url;
      });
      URL.revokeObjectURL(url);
      const naturalW = image.naturalWidth || image.width || 800;
      const naturalH = image.naturalHeight || image.height || 400;
      const scale = Math.min(1, 1200 / Math.max(naturalW, naturalH));
      const width = Math.max(1, Math.round(naturalW * scale));
      const height = Math.max(1, Math.round(naturalH * scale));
      const canvas = document.createElement('canvas');
      canvas.width = width; canvas.height = height;
      const ctx = canvas.getContext('2d', { willReadFrequently: true });
      ctx.clearRect(0, 0, width, height);
      ctx.drawImage(image, 0, 0, width, height);
      const pixels = ctx.getImageData(0, 0, width, height);
      const foil = hexToRgb(targetColor);
      for (let i = 0; i < pixels.data.length; i += 4) {
        const alpha = pixels.data[i + 3] / 255;
        if (!alpha) continue;
        const lum = (0.2126 * pixels.data[i]) + (0.7152 * pixels.data[i + 1]) + (0.0722 * pixels.data[i + 2]);
        const darkness = Math.max(0, Math.min(1, (245 - lum) / 220));
        pixels.data[i] = foil.r;
        pixels.data[i + 1] = foil.g;
        pixels.data[i + 2] = foil.b;
        pixels.data[i + 3] = Math.round(255 * alpha * darkness);
      }
      ctx.putImageData(pixels, 0, 0);
      panel.preview.innerHTML = '';
      const out = document.createElement('img');
      out.alt = 'Approximate logo preview';
      out.src = canvas.toDataURL('image/png');
      panel.preview.appendChild(out);
      panel.preview.hidden = false;
      panel.svgFile = file;
      return true;
    } catch (error) {
      console.warn('PB Logo V3 SVG preview unavailable', error);
      placeholder(panel);
      return false;
    }
  };

  const renderSvgFile = (panel, file, targetColor) => {
    const pending = renderSvgFileNow(panel, file, targetColor);
    const jobs = panel.root.pbDesignPending || (panel.root.pbDesignPending = new Set());
    jobs.add(pending);
    pending.finally(() => jobs.delete(pending));
    return pending;
  };

  const previewColor = panel => {
    if (panel.kind === 'usb') return panel.usbColorGetter?.() || '#ffffff';
    return panel.foilGetter?.().color || '#C8A95A';
  };

  const rerenderPreview = panel => {
    if (!panel.active()) return;
    if (panel.svgFile) renderSvgFile(panel, panel.svgFile, previewColor(panel));
    else if (panel.selection?.previewUrl) {
      panel.preview.innerHTML = '';
      const image = document.createElement('img');
      image.src = String(panel.selection.previewUrl);
      image.alt = 'Saved logo preview';
      panel.preview.appendChild(image);
      panel.preview.hidden = false;
    } else placeholder(panel, panel.selection?.name ? `${panel.selection.name} logo will be applied here` : 'Your logo will be applied here');
  };

  const basePanel = (root, kind, anchor, type, options = {}) => {
    let panelEl = q(root, `[data-pb-logo-v3="${kind}"]`);
    if (!panelEl) {
      panelEl = document.createElement('div');
      panelEl.className = 'pb-logo-v3';
      panelEl.dataset.pbLogoV3 = kind;
      panelEl.hidden = true;
      anchor?.after(panelEl);
    }

    const panel = {
      root, kind, type, el: panelEl, button: q(root, `[data-pb-logo="${kind}"]`),
      preview: previewFor(root, kind), selection: null, file: null, svgFile: null,
      profileGetter: options.profileGetter, foilGetter: options.foilGetter,
      usbColorGetter: options.usbColorGetter, variantsGetter: options.variantsGetter,
      contextGetter: options.contextGetter, textFields: options.textFields || [],
      showContainer: options.showContainer || null,
      active() { return !!this.button?.classList.contains('is-active'); }
    };
    return panel;
  };

  const renderLoggedOut = panel => {
    panel.el.innerHTML = `
      <div class="pb-logo-v3__signin">
        <h4>Sign in to add a logo</h4>
        <p>Your account lets us save your logo dies, so you won't be charged the setup fee again when you reuse one.</p>
        <a href="${CONFIG.loginUrl || '/account/login'}">Sign in or create an account</a>
      </div>`;
  };

  const allowedFile = file => {
    if (!file) return false;
    return /\.(svg|pdf|png)$/i.test(file.name || '');
  };

  const fileFields = (panel, requireName = true) => {
    const wrap = document.createElement('div');
    wrap.className = 'pb-logo-v3__fields';
    wrap.dataset.pbLogoV3Fields = '';
    wrap.innerHTML = `
      ${requireName ? '<div class="pb-logo-v3__field"><label>Logo / brand name <span>*</span></label><input type="text" data-pb-logo-v3-name maxlength="80" placeholder="e.g. Anastasia Weddings"></div>' : ''}
      <div class="pb-logo-v3__field">
        <label>Upload logo artwork <span>*</span></label>
        <input class="pb-logo-v3__file" type="file" accept=".svg,.pdf,.png" data-pb-logo-v3-file>
        <div class="pb-logo-v3__preview-help"><strong>Want to preview your logo?</strong><br>Upload a black logo on a white or transparent background as an SVG and we'll preview it in your selected finish. PDF and high-resolution transparent PNG files are also accepted for production, but may not display in the preview.</div>
        <div class="pb-logo-v3__status" data-pb-logo-v3-file-status>SVG preferred. PDF or high-resolution transparent PNG also accepted.</div>
      </div>`;
    const input = q(wrap, '[data-pb-logo-v3-file]');
    input?.addEventListener('change', async () => {
      const file = input.files?.[0] || null;
      const status = q(wrap, '[data-pb-logo-v3-file-status]');
      if (file && !allowedFile(file)) {
        input.value = '';
        panel.file = null; panel.svgFile = null;
        if (status) status.textContent = 'Please upload an SVG, PDF or PNG file.';
        placeholder(panel);
        return;
      }
      panel.file = file;
      panel.svgFile = null;
      if (!file) { placeholder(panel); return; }
      if (/\.svg$/i.test(file.name)) {
        const rendered = await renderSvgFile(panel, file, previewColor(panel));
        if (status) status.textContent = rendered
          ? 'SVG preview loaded. This is an approximate placement and foil/engraving preview.'
          : 'Artwork received. A live preview was not available, but your production file will still be attached.';
      } else {
        placeholder(panel);
        if (status) status.textContent = 'Artwork received. Live logo preview is available for compatible black-and-white SVG files.';
      }
      message(panel.root, '');
    });
    return wrap;
  };

  const sourceButton = (candidate, labelPrice) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'pb-logo-v3__source';
    const copy = document.createElement('span');
    const name = document.createElement('strong');
    name.textContent = candidate.name || 'Logo';
    const detail = document.createElement('small');
    detail.textContent = candidate.detail || '';
    copy.append(name, detail);
    const price = document.createElement('span');
    price.className = 'pb-logo-v3__source-price';
    price.textContent = labelPrice || '';
    button.append(copy, price);
    button._pbCandidate = candidate;
    return button;
  };

  const chooseSource = (panel, button, candidate) => {
    qa(panel.el, '.pb-logo-v3__source').forEach(el => el.classList.remove('is-active'));
    button.classList.add('is-active');
    panel.selection = candidate;
    panel.file = null; panel.svgFile = null;
    const fields = q(panel.el, '[data-pb-logo-v3-fields]');
    if (fields) fields.hidden = candidate.source !== 'new' && candidate.needsUpload !== true;
    if (candidate.source === 'new' || candidate.needsUpload) {
      panel.file = null;
      const fileInput = q(fields, '[data-pb-logo-v3-file]');
      if (fileInput) fileInput.value = '';
    }
    rerenderPreview(panel);
    refreshSelectedPrice(panel.root);
  };

  const renderBoxPanel = async panel => {
    if (!CONFIG.loggedIn) { renderLoggedOut(panel); return; }
    const profile = panel.profileGetter();
    const cartDies = await currentOrderDies();
    const sameSaved = SAVED_DIES.filter(die => String(die.profile || '') === String(profile || ''));
    const otherSaved = SAVED_DIES.filter(die => String(die.profile || '') !== String(profile || '') && (die.artwork_url || die.preview_url));
    const sameCart = cartDies.filter(die => die.profile === profile);
    const otherCart = cartDies.filter(die => die.profile !== profile && die.artworkUrl);

    panel.el.innerHTML = '<h4>Which logo would you like to use?</h4><p>Select a saved compatible die, reuse artwork already in this order, or upload a new logo.</p>';
    const sources = document.createElement('div');
    sources.className = 'pb-logo-v3__sources';
    panel.el.appendChild(sources);

    const candidates = [];
    sameSaved.forEach(die => candidates.push({
      source: 'saved', dieId: die.id || die.die_id, name: die.name || 'Saved logo', profile,
      artworkUrl: die.artwork_url || '', previewUrl: die.preview_url || '', requiresSetup: false,
      detail: 'Saved compatible logo die — ready to reuse'
    }));
    sameCart.forEach(die => candidates.push({
      source: 'cart', requestId: die.requestId, name: die.name, profile,
      artworkUrl: die.artworkUrl, requiresSetup: !die.setupPaid,
      detail: die.setupPaid ? 'Already uploaded for this order — no additional die setup' : 'Already uploaded — setup line will be restored'
    }));

    candidates.forEach(candidate => {
      const button = sourceButton(candidate, candidate.requiresSetup ? '+$30 setup' : 'No setup fee');
      sources.appendChild(button);
      button.addEventListener('click', () => chooseSource(panel, button, candidate));
    });

    if (otherSaved.length || otherCart.length) {
      const title = document.createElement('div');
      title.className = 'pb-logo-v3__section-title';
      title.textContent = 'Reuse existing artwork in a new die size';
      panel.el.appendChild(title);
      const otherWrap = document.createElement('div');
      otherWrap.className = 'pb-logo-v3__sources';
      panel.el.appendChild(otherWrap);
      otherSaved.forEach(die => {
        const candidate = {
          source: 'saved-new-profile', sourceDieId: die.id || die.die_id, name: die.name || 'Saved logo', profile,
          artworkUrl: die.artwork_url || '', previewUrl: die.preview_url || '', requiresSetup: true,
          needsUpload: !(die.artwork_url), detail: 'Artwork saved, but this product needs a different physical die size'
        };
        const button = sourceButton(candidate, '+$30 new die');
        otherWrap.appendChild(button);
        button.addEventListener('click', () => chooseSource(panel, button, candidate));
      });
      otherCart.forEach(die => {
        const candidate = {
          source: 'cart-new-profile', sourceRequestId: die.requestId, name: die.name, profile,
          artworkUrl: die.artworkUrl, requiresSetup: true, detail: 'Artwork already in this order, but a different die size is required'
        };
        const button = sourceButton(candidate, '+$30 new die');
        otherWrap.appendChild(button);
        button.addEventListener('click', () => chooseSource(panel, button, candidate));
      });
    }

    const title = document.createElement('div');
    title.className = 'pb-logo-v3__section-title';
    title.textContent = 'New logo';
    panel.el.appendChild(title);
    const newCandidate = {
      source: 'new', name: 'Upload a new logo', profile, requiresSetup: true, needsUpload: true,
      detail: 'A new reusable metal die will be made for this logo'
    };
    const newButton = sourceButton(newCandidate, '+$30 one-time setup');
    panel.el.appendChild(newButton);
    const fields = fileFields(panel, true);
    panel.el.appendChild(fields);
    newButton.addEventListener('click', () => chooseSource(panel, newButton, newCandidate));

    if (!candidates.length) newButton.click();
    else chooseSource(panel, sources.querySelector('.pb-logo-v3__source'), candidates[0]);
  };

  const renderUsbPanel = panel => {
    if (!CONFIG.loggedIn) { renderLoggedOut(panel); return; }
    panel.el.innerHTML = '<h4>Upload your logo</h4><p>Upload the artwork you would like engraved onto the USB.</p>';
    panel.selection = { source: 'usb-upload', name: 'USB logo', requiresSetup: false, needsUpload: true };
    const fields = fileFields(panel, false);
    panel.el.appendChild(fields);
  };

  const showPanel = async panel => {
    panel.el.hidden = false;
    if (panel.showContainer) panel.showContainer.hidden = false;
    panel.textFields.forEach(field => { if (field) field.hidden = true; });
    hideTextPreview(panel.root);
    panel.preview.hidden = false;
    placeholder(panel);
    if (panel.type === 'box') await renderBoxPanel(panel);
    else renderUsbPanel(panel);
    refreshSelectedPrice(panel.root);
  };

  const hidePanel = panel => {
    panel.el.hidden = true;
    panel.preview.hidden = true;
    panel.selection = null;
    panel.file = null;
    panel.svgFile = null;
    panel.textFields.forEach(field => { if (field) field.hidden = false; });
    restoreTextPreview(panel.root);
  };

  const bindMode = (panel, nativeButtons) => {
    panel.button?.addEventListener('click', async event => {
      event.preventDefault();
      nativeButtons.forEach(button => button?.classList.remove('is-active'));
      panel.button.classList.add('is-active');
      message(panel.root, '');
      await showPanel(panel);
    });
    nativeButtons.forEach(button => button?.addEventListener('click', () => {
      panel.button?.classList.remove('is-active');
      hidePanel(panel);
      setTimeout(() => refreshSelectedPrice(panel.root), 0);
    }));
  };

  const boxMode = (root, panel, groupSelector, dataKey) => {
    if (panel?.active()) return 'logo';
    return selectedData(root, groupSelector, dataKey) === 'personalized' ? 'text' : 'blank';
  };
  const usbMode = (root, panel) => {
    if (panel?.active()) return 'logo';
    return selectedData(root, '[data-usb-engraving]', 'usbEngraving') === 'yes' ? 'text' : 'none';
  };

  const roots = new Map();

  const photoInit = root => {
    const variants = parse(root, '[data-pb-variants-json]', []);
    const group = q(root, '[data-pb-personalization]');
    const fields = q(root, '[data-pb-personalized-fields]');
    const textCard = qa(fields || root, '.pb-photo-customizer__card').find(card => q(card, '[data-pb-main-input]'));
    const panel = basePanel(root, 'box', fields, 'box', {
      profileGetter: () => CONFIG.productDieProfile,
      foilGetter: () => currentFoil(root),
      variantsGetter: () => variants,
      textFields: [textCard], showContainer: fields
    });
    bindMode(panel, [q(group, '[data-personalization="standard"]'), q(group, '[data-personalization="personalized"]')]);
    roots.set(root, { family: 'photo', variants, box: panel });
  };

  const usbBoxInit = root => {
    const variants = parse(root, '[data-pb-variants-json]', []);
    const products = parse(root, '[data-pb-usb-products-json]', {});
    const pGroup = q(root, '[data-pb-personalization]');
    const pFields = q(root, '[data-pb-personalized-fields]');
    const textCard = qa(pFields || root, '.pb-photo-customizer__card').find(card => q(card, '[data-pb-main-input]'));
    const box = basePanel(root, 'box', pFields, 'box', {
      profileGetter: () => CONFIG.productDieProfile,
      foilGetter: () => currentFoil(root),
      variantsGetter: () => variants,
      textFields: [textCard], showContainer: pFields
    });
    bindMode(box, [q(pGroup, '[data-personalization="standard"]'), q(pGroup, '[data-personalization="personalized"]')]);

    const uGroup = q(root, '[data-pb-usb-engraving]');
    const uFields = q(root, '[data-pb-usb-engraving-fields]');
    const usb = basePanel(root, 'usb', uFields, 'usb', {
      variantsGetter: () => products[selectedData(root, '[data-usb-key]', 'usbKey')]?.variants || [],
      usbColorGetter: () => currentUsbColor(root, products[selectedData(root, '[data-usb-key]', 'usbKey')]),
      textFields: [uFields]
    });
    bindMode(usb, [q(uGroup, '[data-usb-engraving="no"]'), q(uGroup, '[data-usb-engraving="yes"]')]);
    q(root, '[data-usb-choice="none"]')?.addEventListener('click', () => { usb.button?.classList.remove('is-active'); hidePanel(usb); });

    roots.set(root, { family: 'usb-box', variants, usbProducts: products, box, usb });
  };

  const standaloneInit = root => {
    const variants = parse(root, '[data-pb-variants-json]', []);
    const products = parse(root, '[data-pb-box-products-json]', {});
    const uGroup = q(root, '[data-pb-usb-engraving]');
    const uFields = q(root, '[data-pb-usb-engraving-fields]');
    const usb = basePanel(root, 'usb', uFields, 'usb', {
      variantsGetter: () => variants,
      usbColorGetter: () => currentUsbColor(root, { type: root.dataset.usbType }),
      textFields: [uFields]
    });
    bindMode(usb, [q(uGroup, '[data-usb-engraving="no"]'), q(uGroup, '[data-usb-engraving="yes"]')]);

    const bGroup = q(root, '[data-pb-box-personalization]');
    const bFields = q(root, '[data-pb-box-text-fields]');
    const main = q(root, '[data-pb-box-main-text]')?.closest('.pb-photo-customizer__field');
    const second = q(root, '[data-pb-box-second-text]')?.closest('.pb-photo-customizer__field');
    const addon = basePanel(root, 'addon', bFields, 'box', {
      profileGetter: () => profileFor(root, 'addon', products),
      foilGetter: () => currentBoxFoil(root),
      variantsGetter: () => products[selectedData(root, '[data-box-key]', 'boxKey')]?.variants || [],
      textFields: [main, second], showContainer: bFields
    });
    bindMode(addon, [q(bGroup, '[data-box-personalization="standard"]'), q(bGroup, '[data-box-personalization="personalized"]')]);
    q(root, '[data-box-choice="none"]')?.addEventListener('click', () => { addon.button?.classList.remove('is-active'); hidePanel(addon); });

    roots.set(root, { family: 'standalone', variants, boxProducts: products, usb, addon });
  };

  qa(document, '[id^="PBPhotoBoxCustomizer-"]').forEach(photoInit);
  qa(document, '[id^="PBUSBBoxCustomizer-"]').forEach(usbBoxInit);
  qa(document, '[id^="PBStandaloneUSBCustomizer-"]').forEach(standaloneInit);

  const selectedUsb = (root, model) => {
    if (selectedData(root, '[data-usb-choice]', 'usbChoice', 'none') !== 'add') return null;
    const key = selectedData(root, '[data-usb-key]', 'usbKey');
    const product = model.usbProducts[key];
    const capacity = currentCapacity(root);
    const mode = usbMode(root, model.usb);
    return { key, product, capacity, mode, variant: usbVariant(product?.variants || [], capacity, mode) };
  };

  const selectedAddonBox = (root, model) => {
    if (selectedData(root, '[data-box-choice]', 'boxChoice', 'none') !== 'add') return null;
    const key = selectedData(root, '[data-box-key]', 'boxKey');
    const color = selectedData(root, '[data-box-color]', 'boxColor');
    const product = model.boxProducts[key];
    const mode = boxMode(root, model.addon, '[data-pb-box-personalization]', 'boxPersonalization');
    return { key, color, product, mode, variant: boxVariant(product?.variants || [], color, mode) };
  };

  function refreshSelectedPrice(root) {
    const model = roots.get(root);
    if (!model) return;
    const anyLogo = model.box?.active() || model.usb?.active() || model.addon?.active();
    if (!anyLogo) return;
    let total = 0;
    let valid = true;

    if (model.family === 'photo') {
      const variant = boxVariant(model.variants, currentColor(root), 'logo');
      valid = !!variant?.available;
      if (variant) total += Number(variant.price || 0);
    } else if (model.family === 'usb-box') {
      const mode = boxMode(root, model.box, '[data-pb-personalization]', 'personalization');
      const box = boxVariant(model.variants, currentColor(root), mode);
      valid = !!box?.available;
      if (box) total += Number(box.price || 0);
      const usb = selectedUsb(root, model);
      if (usb) {
        valid = valid && !!usb.variant?.available;
        if (usb.variant) total += Number(usb.variant.price || 0);
      }
    } else {
      const mode = usbMode(root, model.usb);
      const usb = usbVariant(model.variants, currentCapacity(root), mode);
      valid = !!usb?.available;
      if (usb) total += Number(usb.price || 0);
      const box = selectedAddonBox(root, model);
      if (box) {
        valid = valid && !!box.variant?.available;
        if (box.variant) total += Number(box.variant.price || 0);
      }
    }

    qa(root, '[data-pb-price]').forEach(el => { el.textContent = valid ? money(total) : 'Variant not set'; });
    const add = q(root, '[data-pb-add]');
    if (add) {
      add.disabled = !valid;
      add.textContent = valid ? 'Add to cart' : 'Unavailable';
    }
  }

  const panelReady = panel => {
    if (!panel?.active()) return { ok: true, data: null };
    if (!CONFIG.loggedIn) return { ok: false, error: 'Please sign in before adding logo personalization.' };
    if (!panel.selection) return { ok: false, error: 'Please choose which logo you would like to use.' };
    if (panel.type === 'usb') {
      if (!panel.file) return { ok: false, error: 'Please upload your USB logo artwork.' };
      return { ok: true, data: { source: 'usb-upload', file: panel.file } };
    }

    const selection = panel.selection;
    let name = selection.name || '';
    const fields = q(panel.el, '[data-pb-logo-v3-fields]');
    if (selection.source === 'new' || selection.needsUpload) {
      const nameInput = q(fields, '[data-pb-logo-v3-name]');
      if (nameInput) name = nameInput.value.trim();
      if (!name) return { ok: false, error: 'Please enter a logo or brand name.' };
      if (!panel.file && !selection.artworkUrl) return { ok: false, error: 'Please upload your logo artwork.' };
    }
    return { ok: true, data: { ...selection, name, file: panel.file || null } };
  };

  const dieProperties = (panel, ready) => {
    const profile = panel.profileGetter();
    const source = ready.data;
    const props = {
      '_PB_Die_Profile': profile,
      '_PB_Logo_Name': source.name,
      '_PB_Logo_Source': source.source,
      'Logo Name': source.name
    };
    let setup = null;

    if (source.source === 'saved') {
      props._PB_Die_ID = source.dieId;
      if (source.artworkUrl) props._PB_Artwork_Reuse_URL = source.artworkUrl;
    } else if (source.source === 'cart') {
      props._PB_Die_Request_ID = source.requestId;
      if (source.artworkUrl) props._PB_Artwork_Reuse_URL = source.artworkUrl;
      if (source.requiresSetup) setup = { requestId: source.requestId, name: source.name, profile };
    } else {
      const requestId = uid();
      props._PB_Die_Request_ID = requestId;
      props._PB_Die_Status = 'pending';
      if (source.sourceDieId) props._PB_Source_Die_ID = source.sourceDieId;
      if (source.sourceRequestId) props._PB_Source_Die_Request_ID = source.sourceRequestId;
      if (source.artworkUrl) props._PB_Artwork_Reuse_URL = source.artworkUrl;
      setup = { requestId, name: source.name, profile };
    }

    return { props, setup };
  };

  const addPropertyFile = (props, key, file) => { if (file) props[key] = file; };

  const prepareSetupItem = setup => {
    if (!setup || !CONFIG.setupVariantId) return null;
    return {
      id: CONFIG.setupVariantId,
      quantity: 1,
      properties: {
        '_PB_Internal_Fee': 'Logo Die Setup',
        '_PB_Die_Request_ID': setup.requestId,
        '_PB_Die_Profile': setup.profile,
        '_PB_Logo_Name': setup.name,
        'Logo Die Setup For': setup.name
      }
    };
  };

  const addTextBoxProps = (root, prefix = '') => {
    const foil = prefix ? currentBoxFoil(root).name : currentFoil(root).name;
    if (prefix) return {
      'Box Foil Color': foil,
      'Box Main Text': q(root, '[data-pb-box-main-text]')?.value?.trim() || '',
      'Box Optional Second Line': q(root, '[data-pb-box-second-text]')?.value?.trim() || ''
    };
    return {
      'Foil Color': foil,
      'Font': 'Goudy',
      'Main Text': q(root, '[data-pb-main-input]')?.value?.trim() || '',
      'Optional Second Line': q(root, '[data-pb-second-input]')?.value?.trim() || ''
    };
  };

  const appendItem = (form, index, item) => {
    form.append(`items[${index}][id]`, item.id);
    form.append(`items[${index}][quantity]`, item.quantity);
    Object.entries(item.properties || {}).forEach(([key, value]) => {
      if (value === null || value === undefined || value === '') return;
      const field = `items[${index}][properties][${key}]`;
      if (value instanceof File) form.append(field, value, value.name);
      else form.append(field, String(value));
    });
  };

  const sendItems = async (root, items) => {
    const add = q(root, '[data-pb-add]');
    if (add) { add.disabled = true; add.textContent = 'Adding...'; }
    try {
      const form = new FormData();
      items.forEach((item, index) => appendItem(form, index, item));
      const response = await window.PBDesignSnapshot.add(root, `${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: form
      });
      if (!response.ok) {
        let error = {};
        try { error = await response.json(); } catch {}
        throw new Error(error.description || error.message || 'Cart add failed');
      }
      cartPromise = null;
      window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
    } catch (error) {
      console.error('PB Logo V3 add failed', error);
      message(root, `Sorry, we could not add this customized item to cart. ${error.message || 'Please try again.'}`);
      if (add) { add.disabled = false; add.textContent = 'Add to cart'; }
    }
  };

  const buildItems = async (root, model) => {
    const qty = Number(q(root, '[data-pb-quantity]')?.value || 1);
    const items = [];
    const setups = [];

    if (model.family === 'photo') {
      const ready = panelReady(model.box);
      if (!ready.ok) return { error: ready.error };
      const variant = boxVariant(model.variants, currentColor(root), 'logo');
      if (!variant?.available) return { error: 'The Add Foil Logo variant is not set for this color yet.' };
      const die = dieProperties(model.box, ready);
      const props = { 'Personalization Type': 'Foil Logo', 'Foil Color': currentFoil(root).name, ...die.props };
      addPropertyFile(props, 'Logo Artwork', ready.data.file);
      if (!ready.data.file && ready.data.artworkUrl) props['Logo Artwork'] = ready.data.artworkUrl;
      items.push({ id: variant.id, quantity: qty, properties: props });
      if (die.setup) setups.push(die.setup);
    }

    if (model.family === 'usb-box') {
      const boxModeNow = boxMode(root, model.box, '[data-pb-personalization]', 'personalization');
      const boxV = boxVariant(model.variants, currentColor(root), boxModeNow);
      if (!boxV?.available) return { error: boxModeNow === 'logo' ? 'The Add Foil Logo variant is not set for this box color yet.' : 'This box combination is unavailable.' };
      let boxProps = {};
      if (boxModeNow === 'text') {
        if (!q(root, '[data-pb-main-input]')?.value?.trim()) return { error: 'Please enter the main foil text.' };
        boxProps = addTextBoxProps(root);
      }
      if (boxModeNow === 'logo') {
        const ready = panelReady(model.box); if (!ready.ok) return { error: ready.error };
        const die = dieProperties(model.box, ready);
        boxProps = { 'Personalization Type': 'Foil Logo', 'Foil Color': currentFoil(root).name, ...die.props };
        addPropertyFile(boxProps, 'Logo Artwork', ready.data.file);
        if (!ready.data.file && ready.data.artworkUrl) boxProps['Logo Artwork'] = ready.data.artworkUrl;
        if (die.setup) setups.push(die.setup);
      }
      items.push({ id: boxV.id, quantity: qty, properties: boxProps });

      const usb = selectedUsb(root, model);
      if (usb) {
        if (!usb.variant?.available) return { error: usb.mode === 'logo' ? 'The Add Logo Engraving variant is not set for this USB option yet.' : 'The selected USB option is unavailable.' };
        const props = {
          'Added with': CONFIG.productTitle || 'Box',
          'USB Style': usb.product?.title || 'USB Drive',
          'Capacity': usb.capacity,
          'USB Engraving': usb.mode === 'none' ? 'No' : usb.mode === 'logo' ? 'Logo' : 'Yes'
        };
        if (usb.mode === 'text') {
          const value = q(root, '[data-pb-usb-engraving-text]')?.value?.trim();
          if (!value) return { error: 'Please enter the USB engraving text.' };
          props['USB Engraving Text'] = value;
          props['USB Engraving Font'] = q(root, '[data-pb-usb-engraving-font]')?.value || 'goudy';
          props['USB Engraving Color'] = currentUsbColor(root, usb.product) === '#ffffff' ? 'White' : 'Dark Brown';
        }
        if (usb.mode === 'logo') {
          const ready = panelReady(model.usb); if (!ready.ok) return { error: ready.error };
          props['USB Engraving Color'] = currentUsbColor(root, usb.product) === '#ffffff' ? 'White' : 'Dark Brown';
          props['USB Logo Artwork'] = ready.data.file;
          props['USB Personalization Type'] = 'Logo Engraving';
        }
        items.push({ id: usb.variant.id, quantity: qty, properties: props });
      }
    }

    if (model.family === 'standalone') {
      const mode = usbMode(root, model.usb);
      const usbV = usbVariant(model.variants, currentCapacity(root), mode);
      if (!usbV?.available) return { error: mode === 'logo' ? 'The Add Logo Engraving variant is not set for this capacity yet.' : 'This USB combination is unavailable.' };
      const usbProps = { 'USB Capacity': currentCapacity(root), 'USB Engraving': mode === 'none' ? 'No' : mode === 'logo' ? 'Logo' : 'Yes' };
      if (mode === 'text') {
        const value = q(root, '[data-pb-usb-engraving-text]')?.value?.trim();
        if (!value) return { error: 'Please enter your USB engraving text.' };
        usbProps['USB Engraving Text'] = value;
        usbProps['USB Engraving Font'] = q(root, '[data-pb-usb-engraving-font]')?.value || 'goudy';
        usbProps['USB Engraving Color'] = currentUsbColor(root, { type: root.dataset.usbType }) === '#ffffff' ? 'White' : 'Dark Brown';
      }
      if (mode === 'logo') {
        const ready = panelReady(model.usb); if (!ready.ok) return { error: ready.error };
        usbProps['USB Engraving Color'] = currentUsbColor(root, { type: root.dataset.usbType }) === '#ffffff' ? 'White' : 'Dark Brown';
        usbProps['USB Logo Artwork'] = ready.data.file;
        usbProps['USB Personalization Type'] = 'Logo Engraving';
      }
      items.push({ id: usbV.id, quantity: qty, properties: usbProps });

      const box = selectedAddonBox(root, model);
      if (box) {
        if (!box.key || !box.color) return { error: 'Please choose a presentation box style and color.' };
        if (!box.variant?.available) return { error: box.mode === 'logo' ? 'The Add Foil Logo variant is not set for this presentation box yet.' : 'The selected presentation box is unavailable.' };
        let props = {
          '_Source': 'Standalone USB Customizer',
          'Box Style': box.product?.label || box.key,
          'Box Color': box.color,
          'Box Personalization': box.mode === 'blank' ? 'Blank Box' : box.mode === 'logo' ? 'Add Foil Logo' : 'Add Foil Text'
        };
        if (box.mode === 'text') {
          const value = q(root, '[data-pb-box-main-text]')?.value?.trim();
          if (!value) return { error: 'Please enter the box personalization text.' };
          props = { ...props, ...addTextBoxProps(root, 'box') };
        }
        if (box.mode === 'logo') {
          const ready = panelReady(model.addon); if (!ready.ok) return { error: ready.error };
          const die = dieProperties(model.addon, ready);
          props = { ...props, 'Box Foil Color': currentBoxFoil(root).name, 'Personalization Type': 'Foil Logo', ...die.props };
          addPropertyFile(props, 'Box Logo Artwork', ready.data.file);
          if (!ready.data.file && ready.data.artworkUrl) props['Box Logo Artwork'] = ready.data.artworkUrl;
          if (die.setup) setups.push(die.setup);
        }
        items.push({ id: box.variant.id, quantity: qty, properties: props });
      }
    }

    if (setups.length) {
      const existingCart = await getCart(true);
      const paid = new Set((existingCart.items || [])
        .filter(item => item.properties?._PB_Internal_Fee === 'Logo Die Setup' || String(item.variant_id || item.id) === String(CONFIG.setupVariantId || ''))
        .map(item => item.properties?._PB_Die_Request_ID)
        .filter(Boolean));
      setups.forEach(setup => {
        if (paid.has(setup.requestId)) return;
        const item = prepareSetupItem(setup);
        if (item) items.push(item);
      });
    }
    return { items };
  };

  roots.forEach((model, root) => {
    const add = q(root, '[data-pb-add]');
    add?.addEventListener('click', async event => {
      const anyLogo = model.box?.active() || model.usb?.active() || model.addon?.active();
      if (!anyLogo) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (root.pbLogoAdding) return;
      root.pbLogoAdding = true;
      const scope = q(root, '.pb-photo-customizer__modal, .pb-usb-customizer__modal, .pb-standalone-usb-customizer__modal') || root;
      const wasInert = scope.inert;
      scope.inert = true;
      try {
        const result = await buildItems(root, model);
        if (result.error) { message(root, result.error); return; }
        if (result.items?.length) await sendItems(root, result.items);
      } finally {
        scope.inert = wasInert;
        root.pbLogoAdding = false;
      }
    }, true);

    ['click', 'change'].forEach(eventName => root.addEventListener(eventName, event => {
      if (event.target.closest('[data-foil], [data-box-foil-name]')) {
        setTimeout(() => {
          [model.box, model.usb, model.addon].filter(Boolean).forEach(panel => {
            if (panel.active()) rerenderPreview(panel);
          });
        }, 0);
      }
      setTimeout(() => refreshSelectedPrice(root), 0);
    }));
  });

  window.PBLogoV3 = { refreshSelectedPrice, getCart };
})();

